<template>
	<div class="related-transactions" v-show="!loading">
		<span ref="contentPageHeading" class="related-transactions__title">
			Related Transactions
		</span>
		<ScrollContainer
			class="related-transactions__list"
			v-if="hasResults"
			variant="infinity-scroll"
			:takeAvailableHeight="false"
			:hasMoreItems="hasMoreItemsToLoad"
			@scrollEnd="handleScrollEnd"
		>
			<GlobalTransactionsList :items="globalTransactionsList">
			</GlobalTransactionsList>
		</ScrollContainer>
	</div>
</template>

<script>
import GlobalTransactionsList from '@/sections/transactions/shared/transactions-list';
import ScrollContainer from '@/components/shells/scroll-container/scroll-container';
import {
	MODULE_NAME,
	GLOBAL_TRANSACTIONS
} from '@/sections/transactions/transactions-mutation-types.js';
import { mapActions, mapState } from 'vuex';

export default {
	name: 'GlobalTransactionsDetailsRelatedTransactions',
	components: {
		GlobalTransactionsList,
		ScrollContainer
	},
	props: {
		correlationId: {
			type: String,
			required: true
		},
		excludeTransactionId: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			parameters: {
				maxCount: 10,
				orderBy: 'timestamp',
				orderDirection: 'desc',
				correlationId: this.correlationId,
				excludeTransactionId: this.excludeTransactionId
			},
			loading: false,
			loadingMore: false,
			recordStart: 1
		};
	},
	computed: {
		...mapState(MODULE_NAME, [GLOBAL_TRANSACTIONS]),

		globalTransactionsList() {
			return this[GLOBAL_TRANSACTIONS]?.items || [];
		},
		hasResults() {
			return (
				this.globalTransactionsList?.length &&
				!this.loadingRelatedTransactions
			);
		},
		hasMoreItemsToLoad() {
			return (
				this[GLOBAL_TRANSACTIONS].page <
				this[GLOBAL_TRANSACTIONS].totalPageCount
			);
		}
	},
	methods: {
		...mapActions('globaltransactions', ['setGlobalTransactions']),

		async fetchData(recordStart) {
			try {
				let query = { ...this.parameters };
				query.correlationId = this.correlationId;
				query.recordStart = recordStart || 1;
				if (!this.loadingMore) {
					this.loading = true;
				}
				await this.setGlobalTransactions(query);
			} finally {
				this.loading = false;
				this.loadingMore = false;
			}
		},
		handleScrollEnd() {
			if (this.hasMoreItemsToLoad) {
				this.loadingMore = true;
				this.recordStart += 1;
			}
		}
	},
	watch: {
		correlationId: {
			immediate: true,
			handler(val) {
				if (val) {
					this.fetchData(1);
				}
			}
		},
		recordStart: {
			handler(recordStart) {
				this.fetchData(recordStart);
			}
		}
	}
};
</script>

<style lang="scss">
/**
  *
  * Global Transactions - Related Transactions
  * Can use SCSS variables = TRUE
  *
**/

.related-transactions {
	&__title {
		@include heading('md');
	}

	&__list {
		margin-top: $gutter-xl;
		max-height: 420px;
	}
}
</style>
